<template>
  <navbar :showNavbar="showTopNavBar" type="black">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-sm btn-icon  btn-round" @click="minimizeSidebar">
          <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
          <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
        </button>
      </div>
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar">

        </navbar-toggle-button>
      </div>
      <a class="navbar-brand">{{this.$route.name}}</a>
    </div>


    <!-- <template slot="navbar-menu"> -->
      <!-- <form>
        <div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Search...">
          <div class="input-group-append">
            <div class="input-group-text">
              <i class="nc-icon nc-zoom-split"></i>
            </div>
          </div>
        </div>
      </form>
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link btn-magnify" href="#">
            <i class="nc-icon nc-layout-11"></i>
            <p>
              <span class="d-lg-none d-md-block">Stats</span>
            </p>
          </a>
        </li> -->

        <drop-down
                   tag="li"
                   position="right"
                   direction="none"
                   class="nav-info-list nav-item btn-rotate dropdown">
          <a id="notifications"
             slot="title"
             slot-scope="{isOpen}"
             class="nav-link dropdown-toggle"
             data-toggle="dropdown"
             aria-haspopup="true"
             :aria-expanded="isOpen"
             @click="toggleNotificationDropDown">
            <!-- <i class="nc-icon nc-bell-55"></i> -->
            <img src="static/img/icons/icon-bell-notification-fill.png" height="35"></img>

            <!-- <p>
              <span class="d-lg-none d-md-block">Notificaciones</span>
            </p> -->
          </a>
          <!-- <a class="dropdown-item" href="#">Action</a> -->

        </drop-down>

        <a id="interfaz-anterior" class="nav-link" href="http://200.10.100.100" target="_blank">
            <button type="button" class="btn btn-labeled btn-default">
                <span class="btn-label"><i class="nc-icon nc-laptop"></i></span>
                &nbsp;&nbsp;Interfaz Anterior
            </button>
        </a>

        <!-- <li class="nav-item">
          <a class="nav-link btn-rotate" href="#">
            <i class="nc-icon nc-settings-gear-65"></i>
            <p>
              <span class="d-lg-none d-md-block">Account</span>
            </p>
          </a>
        </li>
      </ul> -->
    <!-- </template> -->

    <div id="notifications-container" v-if="this.activeNotifications" class=" event-notify-list col-lg-4 col-md-8 text-center">
        <task-list></task-list>
    </div>

  </navbar>
</template>
<script>
  import { Navbar, NavbarToggleButton } from 'src/components/UIComponents'
  import TaskList from '../Views/Dashboard/Widgets/TaskList'

  export default {
    components: {
      Navbar,
      NavbarToggleButton,
      TaskList
    },

    data() {
      return {
        activeNotifications: false,
        showTopNavBar: true
      }
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize()
      },
      toggleNavbar() {
        this.showTopNavBar = !this.showTopNavBar;
      }
    }
  }

</script>
<style scoped>
.navbar-wrapper {
  height: 38px;
}
.nav-link{
  position: absolute;
  right: 0px;
}
a.nav-link.dropdown-toggle{
    width: 100px;
    top: -10px;
    right: -20px;
}


.nav-info-list{
  position: absolute;
  right: 220px;
  top: 10px;
}
.event-notify-list{
 float: right;
 position: absolute;
 right: -10px;
 top: 63px;
 /* TODO: Ajuste automático de altura */
 height: 100%;
 /* min-width: 430px; */

}

</style>
